import React, { PropTypes } from 'react';
import Icon from './../Icon';
import styles from './ToggleNav.scss'
import CSSModules from 'react-css-modules'



const ToggleNav = (props) => {
    return (
        <button styleName="button" onClick={ () => props.toggleNavigation() }>
            { props.isNavigationActive ? (
                <Icon icon="Vitra_MenuOpen.svg" />
            ) : (
                <Icon icon="Vitra_Menu.svg" />
            ) }
        </button>
    )
};

ToggleNav.propTypes = {
    toggleNavigation: PropTypes.func.isRequired,
    isNavigationActive: PropTypes.bool.isRequired,
};

export default CSSModules(ToggleNav, styles);


// WEBPACK FOOTER //
// ./app/components/shared/ToggleNav/index.jsx